











import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class BatteryLevel extends Vue {
  // Props
  @Prop()
  row!: any

  getIcon(level) {
    let icon = `battery-`
    switch (level) {
      case -1:
        icon += `charging`
        break
      case 0:
        icon += `outline`
        break
      case 5:
        icon = `battery`
        break
      default:
        icon += `${level * 20}`
    }
    return icon
  }
}
